<template>
  <div class="space-y-2 prose dark:prose-invert">
    <p>Our services are not intended for children under 18 (or under the legal age for gambling-related services in your jurisdiction).</p>
    <p>We do not knowingly collect personal data from minors.</p>
    <p>If we become aware that a minor has provided us with data, we will promptly delete it.</p>
  </div>
</template>